module.exports = __webpack_public_path__ + "img/index_3.9d72d52c.jpg";